export const MENU_BORDER_RADIUS_PX = 16;
